

// -------- Production extension index ---------
//      ! THIS FILE WAS AUTO-GENERATED !
//
// Do not commit this file, the final index is
// compiled by the repo owner, use index_dev.js to
// experiment: 'npm run compile'

import ALMA from './overlays/ALMA/ALMA.vue'
import ATR from './overlays/ATR/ATR.vue'
import ATRp from './overlays/ATRp/ATRp.vue'
import AcceleratorOscillator from './overlays/AcceleratorOscillator/AcceleratorOscillator.vue'
import Area51 from './overlays/Area51/Area51.vue'
import AreaChart from './overlays/AreaChart/AreaChart.vue'
import AwesomeOscillator from './overlays/AwesomeOscillator/AwesomeOscillator.vue'
import BB from './overlays/BB/BB.vue'
import BBW from './overlays/BBW/BBW.vue'
import Baseline from './overlays/Baseline/Baseline.vue'
import CCI from './overlays/CCI/CCI.vue'
import CMF from './overlays/CMF/CMF.vue'
import CMO from './overlays/CMO/CMO.vue'
import COG from './overlays/COG/COG.vue'
import Columns from './overlays/Columns/Columns.vue'
import Crossover from './overlays/Crossover/Crossover.vue'
import DC from './overlays/DC/DC.vue'
import DEMA from './overlays/DEMA/DEMA.vue'
import DHistogram from './overlays/DHistogram/DHistogram.vue'
import DMI from './overlays/DMI/DMI.vue'
import DeMarker from './overlays/DeMarker/DeMarker.vue'
import EMA from './overlays/EMA/EMA.vue'
import FRAMA from './overlays/FRAMA/FRAMA.vue'
import FisherTransform from './overlays/FisherTransform/FisherTransform.vue'
import HLCArea from './overlays/HLCArea/HLCArea.vue'
import HMA from './overlays/HMA/HMA.vue'
import HeikinAshi from './overlays/HeikinAshi/HeikinAshi.vue'
import HighLow from './overlays/HighLow/HighLow.vue'
import Histogram from './overlays/Histogram/Histogram.vue'
import HollowCandles from './overlays/HollowCandles/HollowCandles.vue'
import Ichi from './overlays/Ichi/Ichi.vue'
import Ichimoku from './overlays/Ichimoku/Ichimoku.vue'
import KAMA from './overlays/KAMA/KAMA.vue'
import KC from './overlays/KC/KC.vue'
import KCW from './overlays/KCW/KCW.vue'
import KST from './overlays/KST/KST.vue'
import Kagi from './overlays/Kagi/Kagi.vue'
import LSR from './overlays/LSR/LSR.vue'
import LT from './overlays/LT/LT.vue'
import LinReg from './overlays/LinReg/LinReg.vue'
import LineBreak from './overlays/LineBreak/LineBreak.vue'
import LineChart from './overlays/LineChart/LineChart.vue'
import LineMarkers from './overlays/LineMarkers/LineMarkers.vue'
import LinearRegressionChannel from './overlays/LinearRegressionChannel/LinearRegressionChannel.vue'
import LongShortTrades from './overlays/LongShortTrades/LongShortTrades.vue'
import MACD from './overlays/MACD/MACD.vue'
import MFI from './overlays/MFI/MFI.vue'
import MM from './overlays/MM/MM.vue'
import MOM from './overlays/MOM/MOM.vue'
import MTA from './overlays/MTA/MTA.vue'
import MTFTargets from './overlays/MTFTargets/MTFTargets.vue'
import MakersMove from './overlays/MakersMove/MakersMove.vue'
import Markers from './overlays/Markers/Markers.vue'
import MultiTimeframeAnalysis from './overlays/MultiTimeframeAnalysis/MultiTimeframeAnalysis.vue'
import PivotPoints from './overlays/PivotPoints/PivotPoints.vue'
import PlotCross from './overlays/PlotCross/PlotCross.vue'
import PointAndFigure from './overlays/PointAndFigure/PointAndFigure.vue'
import QQE from './overlays/QQE/QQE.vue'
import ROC from './overlays/ROC/ROC.vue'
import RSI from './overlays/RSI/RSI.vue'
import RangeChart from './overlays/RangeChart/RangeChart.vue'
import Renko from './overlays/Renko/Renko.vue'
import Ribbon from './overlays/Ribbon/Ribbon.vue'
import SAR from './overlays/SAR/SAR.vue'
import SMA from './overlays/SMA/SMA.vue'
import SMMA from './overlays/SMMA/SMMA.vue'
import SWMA from './overlays/SWMA/SWMA.vue'
import SplineX from './overlays/SplineX/SplineX.vue'
import StepLine from './overlays/StepLine/StepLine.vue'
import Stoch from './overlays/Stoch/Stoch.vue'
import StochasticRSI from './overlays/StochasticRSI/StochasticRSI.vue'
import SuperTrend from './overlays/SuperTrend/SuperTrend.vue'
import TC from './overlays/TC/TC.vue'
import TEMA from './overlays/TEMA/TEMA.vue'
import TSI from './overlays/TSI/TSI.vue'
import TSMA from './overlays/TSMA/TSMA.vue'
import TimeCycle from './overlays/TimeCycle/TimeCycle.vue'
import TimeframeTrend from './overlays/TimeframeTrend/TimeframeTrend.vue'
import TradesPlus from './overlays/TradesPlus/TradesPlus.vue'
import TradingLevels from './overlays/TradingLevels/TradingLevels.vue'
import VT from './overlays/VT/VT.vue'
import VTCandles from './overlays/VTCandles/VTCandles.vue'
import VTConfidence from './overlays/VTConfidence/VTConfidence.vue'
import VTLaser from './overlays/VTLaser/VTLaser.vue'
import VWAP from './overlays/VWAP/VWAP.vue'
import VWMA from './overlays/VWMA/VWMA.vue'
import VisualCandles from './overlays/VisualCandles/VisualCandles.vue'
import VisualTrading from './overlays/VisualTrading/VisualTrading.vue'
import Volume from './overlays/Volume/Volume.vue'
import VolumeCandles from './overlays/VolumeCandles/VolumeCandles.vue'
import WMA from './overlays/WMA/WMA.vue'
import WilliamsR from './overlays/WilliamsR/WilliamsR.vue'
import XCandles from './overlays/XCandles/XCandles.vue'
import XOhlcBars from './overlays/XOhlcBars/XOhlcBars.vue'
import ZLEMA from './overlays/ZLEMA/ZLEMA.vue'
import ZScore from './overlays/ZScore/ZScore.vue'

const Pack = {
    ALMA,
    ATR,
    ATRp,
    AcceleratorOscillator,
    Area51,
    AreaChart,
    AwesomeOscillator,
    BB,
    BBW,
    Baseline,
    CCI,
    CMF,
    CMO,
    COG,
    Columns,
    Crossover,
    DC,
    DEMA,
    DHistogram,
    DMI,
    DeMarker,
    EMA,
    FRAMA,
    FisherTransform,
    HLCArea,
    HMA,
    HeikinAshi,
    HighLow,
    Histogram,
    HollowCandles,
    Ichi,
    Ichimoku,
    KAMA,
    KC,
    KCW,
    KST,
    Kagi,
    LSR,
    LT,
    LinReg,
    LineBreak,
    LineChart,
    LineMarkers,
    LinearRegressionChannel,
    LongShortTrades,
    MACD,
    MFI,
    MM,
    MOM,
    MTA,
    MTFTargets,
    MakersMove,
    Markers,
    MultiTimeframeAnalysis,
    PivotPoints,
    PlotCross,
    PointAndFigure,
    QQE,
    ROC,
    RSI,
    RangeChart,
    Renko,
    Ribbon,
    SAR,
    SMA,
    SMMA,
    SWMA,
    SplineX,
    StepLine,
    Stoch,
    StochasticRSI,
    SuperTrend,
    TC,
    TEMA,
    TSI,
    TSMA,
    TimeCycle,
    TimeframeTrend,
    TradesPlus,
    TradingLevels,
    VT,
    VTCandles,
    VTConfidence,
    VTLaser,
    VWAP,
    VWMA,
    VisualCandles,
    VisualTrading,
    Volume,
    VolumeCandles,
    WMA,
    WilliamsR,
    XCandles,
    XOhlcBars,
    ZLEMA,
    ZScore
}

if (typeof window !== 'undefined' && window.Vue) {
    window.TcjsOverlays = Pack
}

export default Pack

export {
    ALMA,
    ATR,
    ATRp,
    AcceleratorOscillator,
    Area51,
    AreaChart,
    AwesomeOscillator,
    BB,
    BBW,
    Baseline,
    CCI,
    CMF,
    CMO,
    COG,
    Columns,
    Crossover,
    DC,
    DEMA,
    DHistogram,
    DMI,
    DeMarker,
    EMA,
    FRAMA,
    FisherTransform,
    HLCArea,
    HMA,
    HeikinAshi,
    HighLow,
    Histogram,
    HollowCandles,
    Ichi,
    Ichimoku,
    KAMA,
    KC,
    KCW,
    KST,
    Kagi,
    LSR,
    LT,
    LinReg,
    LineBreak,
    LineChart,
    LineMarkers,
    LinearRegressionChannel,
    LongShortTrades,
    MACD,
    MFI,
    MM,
    MOM,
    MTA,
    MTFTargets,
    MakersMove,
    Markers,
    MultiTimeframeAnalysis,
    PivotPoints,
    PlotCross,
    PointAndFigure,
    QQE,
    ROC,
    RSI,
    RangeChart,
    Renko,
    Ribbon,
    SAR,
    SMA,
    SMMA,
    SWMA,
    SplineX,
    StepLine,
    Stoch,
    StochasticRSI,
    SuperTrend,
    TC,
    TEMA,
    TSI,
    TSMA,
    TimeCycle,
    TimeframeTrend,
    TradesPlus,
    TradingLevels,
    VT,
    VTCandles,
    VTConfidence,
    VTLaser,
    VWAP,
    VWMA,
    VisualCandles,
    VisualTrading,
    Volume,
    VolumeCandles,
    WMA,
    WilliamsR,
    XCandles,
    XOhlcBars,
    ZLEMA,
    ZScore
}